var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',{attrs:{"include":_vm.includeComponents}},[_c(_vm.currComponent,_vm._g(_vm._b({ref:"navigate",tag:"component",on:{"navigate-to":_vm.navigateTo,"reset":_vm.handleReset}},'component',_vm.currParams,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }